import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction, EApiType, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import { handleSuccess, handleApiErrorWithFallback, handleError } from './HttpUtil';
import type { Dispatch } from '@reduxjs/toolkit';

export const PriceListMapApi = {
  getPriceListMap: (
    action: { page: number; limit: number; searchCode?: string },
    dispatch: Dispatch
  ) => {
    const queryParams =
      `${EUrlParams.Page}=` + action.page + `&${EUrlParams.Limit}=` + action.limit;
    return AxiosClient.post(`/price/v1/pricelist/read?${queryParams}`, {
      criteria: action.searchCode ? action.searchCode : '',
    })
      .then((response) => {
        return handlePaginatedData({ ...response, data: response.data.priceMaps }, action);
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: action.page, searchKey: action.searchCode },
          EAction.Read,
          EApiType.PriceListMapKey
        );
      });
  },

  getPriceListMapDetails: (action: { searchCode: string }, dispatch: Dispatch) => {
    return AxiosClient.post('/price/v1/pricelist/read', {
      criteria: action.searchCode ? action.searchCode : '',
    })
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Get);
      });
  },

  updatePriceListMap: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/price/v1/pricelist/create', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Update);
      });
  },
};
